import React, { useContext } from 'react';
import { AccountContext } from '../Account';

const getAccount = () => {
  const account = useContext(AccountContext);
  return account;
};

export default getAccount;
